<template>
  <div>
      <button @click="login">Login</button> Login Google? {{ isLogin }}
  </div>
</template>

<script>
import Vue from "vue";
//import GAuth from 'vue-google-oauth2'

const gauthOption = {
  clientId: '20319378015-mf0mi472v5n6i9926q0nkgf6jqrj9tgv.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'consent', 
  fetch_basic_profile: true,
  plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)
export default {
  data() {
      return {
          isLogin: false,
      };
  },
  methods: {
    async login() {
  try {
      var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
      this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
      console.log('Is user logged in?', this.isLogin);
      var idToken = googleuser.getAuthResponse().id_token;
      console.log("getProfile" + googleuser.getBasicProfile());
      console.log("auth" + googleuser.getAuthResponse());
      console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());
      // If the user is logged in, retrieve the user profile to access the email
      if (this.isLogin) {
      console.log('ID Token:', idToken);
          this.getUserEmail(idToken);
      }
  } catch (error) {
      console.error('Error during login:', error);
  }
},
async getUserEmail(idToken) {
      try {
        const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
        if (response.status === 200) {
          this.user = response.data;
          console.log("email" + this.user);
          this.SetSession(idToken);
        } else {
          // Handle non-200 status code
          console.error("Failed to fetch user information:", response);
        }
      } catch (error) {
        console.error("Error fetching user information:", error);
        // Handle the error here
      }
    },
    async SetSession(idToken) {
            this.lblGoogle = "Processing..";
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                console.log("Response:", response);
                if (response.status === 202) {
                } else if (response.status === 200) {
                    const userData = response.data;
                    console.log("User Data:", userData);
                    const userType = response.data.data.userType;
                    console.log("User Type:", response.data.data.userType);
                    if (userType === 'individual') {
                      this.$router.push("Profile");
                      console.log("User Data profile");
                    } else {
                      console.log("User Data dashboard");
                    }
                    console.error("Failed to fetch user information:", response);
                } else {
                    // Handle other status codes
                   
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
    },

}
</script>
